import React, { Fragment } from 'react';
import { Form, Select } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';

const Tachograph = ({ form, disabled, tachographsTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Тахограф:</span>
      <Form.Item>
        {getFieldDecorator('tachograph')(
          <Select
            mode="multiple"
            dropdownClassName="select select_multiple"
            placeholder="Выберите тип тахографа"
            className="basicInput"
            disabled={disabled}
            showArrow
            getPopupContainer={trigger => trigger.parentNode}
          >
            {tachographsTypes &&
              tachographsTypes.map((type, index) => (
                <Select.Option key={index + 1} value={type.tachographKey}>
                  {type.tachographName}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default transportFieldsConnect(Tachograph, ['tachographsTypes']);
